export const QUEUE_NAME = {
  ONBOARDING: 'ONBOARDING',
  REVIEW: 'REVIEW',
  POST_APPROVAL: 'POST_APPROVAL',
};

export const FRESH_CHAT_GROUP_IDS = {
  AT: {
    [QUEUE_NAME.ONBOARDING]: 1682,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  AU: {
    [QUEUE_NAME.ONBOARDING]: 21887,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  BE: {
    [QUEUE_NAME.ONBOARDING]: 2639,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  DE: {
    [QUEUE_NAME.ONBOARDING]: 31,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  DK: {
    [QUEUE_NAME.ONBOARDING]: 1681,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  ES: {
    [QUEUE_NAME.ONBOARDING]: 2768,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  FI: {
    [QUEUE_NAME.ONBOARDING]: 3818,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  FR: {
    [QUEUE_NAME.ONBOARDING]: null,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  GB: {
    [QUEUE_NAME.ONBOARDING]: 3494,
    [QUEUE_NAME.REVIEW]: 3563,
    [QUEUE_NAME.POST_APPROVAL]: 3563,
  },
  IE: {
    [QUEUE_NAME.ONBOARDING]: 3653,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  IT: {
    [QUEUE_NAME.ONBOARDING]: 3596,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  NL: {
    [QUEUE_NAME.ONBOARDING]: 1680,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  NO: {
    [QUEUE_NAME.ONBOARDING]: 29,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  SE: {
    [QUEUE_NAME.ONBOARDING]: 19,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  PT: {
    [QUEUE_NAME.ONBOARDING]: 3663,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  PL: {
    [QUEUE_NAME.ONBOARDING]: null,
    [QUEUE_NAME.REVIEW]: null,
    [QUEUE_NAME.POST_APPROVAL]: null,
  },
  US: {
    [QUEUE_NAME.ONBOARDING]: 5470,
    [QUEUE_NAME.REVIEW]: 5506,
    [QUEUE_NAME.POST_APPROVAL]: 5506,
  },
};
